import { render, staticRenderFns } from "./editRole.vue?vue&type=template&id=0831f87b&scoped=true"
import script from "./editRole.vue?vue&type=script&lang=js"
export * from "./editRole.vue?vue&type=script&lang=js"
import style0 from "./editRole.vue?vue&type=style&index=0&id=0831f87b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831f87b",
  null
  
)

export default component.exports